module.exports = __webpack_public_path__ + "images/bcc01a7.png";